<ng-template #fileDownloadFailed>
    <p>
        Something went wrong. Please try later.
        If the problem persists. Please contact support.
    </p>
</ng-template>

<ng-template #closeFooter>
    <button phxButton="link" (click)="goBacktoHome()" role="button">Home</button>
</ng-template>